module.exports = __webpack_public_path__ + "static/img/CN@2x.9d64f94d.jpg";